import { AuthContext, useAuthLogic } from '@/hooks';

export function AuthProvider({ children }: { children: React.ReactNode }) {
	const auth = useAuthLogic();
	return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}
